import script from "./BannerAd.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerAd.vue?vue&type=script&setup=true&lang=js"

import "./BannerAd.vue?vue&type=style&index=0&id=8432303e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8432303e"]])

export default __exports__